import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import { setActiveRegion, setComparedRegion, setActiveEntity, setComparedEntity, setActivePage } from '../../actions/ui';
import * as selectors from '../../reducers';
import EntityBanner from './entity-banner';

class EntityInfo extends Component {
    constructor() {
        super();
        this.state = {
            hoveredCouncil: null,
            tooltipPosition: { x: 0, y: 0 },
            mapTooltipVisible: false,
        };
        this.handleCloseClicked = this.handleCloseClicked.bind(this);
        this.hasRenderedOnce = false;
    }

    handleCloseClicked() {
        const {
            isComparisonCouncil,
            comparisonId,
            setActiveEntity,
            setComparedEntity,
        } = this.props;
        if (isComparisonCouncil) {
            // Close the comparison one only
            setComparedEntity(null);
        } else {
            // Close the current active one, and make the other one active.
            setActiveEntity(comparisonId);
            // Now close the comparison one.
            setComparedEntity(null);
        }
    }

    render() {
        const {
            entity,
            comparing,
            entitiesInSameCategory,
            setActiveRegion,
        } = this.props;

        return (
            <div
                className={`councilMapWrapper ${styles.councilMapWrapper}`}
                data-comparing={comparing}
            >
                <EntityBanner
                    entity={entity}
                    comparing={comparing}
                    entitiesInSameCategory={entitiesInSameCategory}
                    onCloseClicked={this.handleCloseClicked}
                    setActiveRegion={setActiveRegion}
                    setActivePage={setActivePage}
                />
            </div>
        );
    }
}

const mapDispatchToProps = {
    setActiveRegion,
    setComparedRegion,
    setComparedEntity,
    setActiveEntity,
};

const mapStateToProps = (state, props) => ({
    qldCouncilsGeo: selectors.getQldCouncilsGeo(state),
    isMobile: selectors.getIsMobile(state),
    entitiesInSameCategory: selectors
        .getEntities(state)
        .filter(x => x)
});

EntityInfo.propTypes = {
    qldCouncilsGeo: PropTypes.object.isRequired,
    onCouncilSelect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityInfo);



// WEBPACK FOOTER //
// ./src/components/entity-info/entity-info.js